import Route from '@ember/routing/route';
import { service } from '@ember/service';

import { findRecord } from 'umg-ember-backend/data/builders/umg-rest';

export default class AdminWebSeriesWebSeriesRoute extends Route {
  // Services
  @service breadcrumb;
  @service store;

  // Hooks
  async model({ web_series_id }) {
    const { content } = await this.store.request(
      findRecord('web-series', web_series_id),
    );

    return content.data;
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
